
import i18n from '@/helpers/i18n';
import store from '@/store';

// Pages allowed for User role (EcommerceManager)
const USER_ALLOWED_PAGES = [
    '/vouchers/lista',
    '/vouchers/adicionar',
    '/vouchers/editar',
    '/guias/lista',
    '/guias/adicionar',
    '/guias/editar',
    '/reservas/lista',
    '/reservas/adicionar',
    '/reservas/editar',
    '/experiencias/lista',
    '/experiencias/adicionar',
    '/experiencias/editar',
    '/horarios/lista',
    '/horarios/adicionar',
    '/horarios/editar',
    '/intervalos-horarios/lista',
    '/intervalos-horarios/adicionar',
    '/intervalos-horarios/editar',
    '/estatisticas',
    '/membros/lista',
    '/membros/adicionar',
    '/membros/editar',
    '/inqueritos',
    '/respostas-inqueritos',
    '/perfil',
    '/logout'
];

function isPageAllowed(path) {
    const isAdmin = store.getters['users/isAdmin'];
    
    // Admin has access to all pages
    if (isAdmin) {
        return true;
    }
    
    // User role (EcommerceManager) only has access to specific pages
    if (store.getters['users/isUser']) {
        return USER_ALLOWED_PAGES.some(allowedPath => path.startsWith(allowedPath));
    }
    
    return false;
}

const allMenuItems = [
    {
        _name: 'CSidebarNavTitle',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('wines'),
        to: '/vinhos/lista',
        icon: 'cil-pin',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('experiences'),
        to: '/experiencias/lista',
        icon: 'cil-calendar',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('vouchers'),
        to: '/vouchers/lista',
        icon: 'cil-tag'
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('guides'),
        to: '/guias/lista',
        icon: 'cil-user-follow',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('reservations'),
        to: '/reservas/lista',
        icon: 'cil-calendar-check',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('schedules'),
        to: '/horarios/lista',
        icon: 'cil-clock',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('availabilityIntervals.intervals'),
        to: '/intervalos-horarios/lista',
        icon: 'cil-calendar',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('statistics'),
        to: '/estatisticas',
        icon: 'cil-chart',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('members'),
        to: '/membros/lista',
        icon: 'cil-people',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('prizes'),
        to: '/premios/lista',
        icon: 'cil-pin',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('heros'),
        to: '/capa/lista',
        icon: 'cil-library',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('keyValues'),
        to: '/informacoes/lista',
        icon: 'cil-library',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('staticInfos'),
        to: '/paginas/lista',
        icon: 'cil-File',
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('satisfactionQuestions'),
        to: '/inqueritos',
        icon: 'cil-task'
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('satisfactionFormAnswers'),
        to: '/respostas-inqueritos',
        icon: 'cil-comment-square'
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('settings'),
        to: '/definicoes',
        icon: 'cil-settings'
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('profile'),
        to: '/perfil',
        icon: 'cil-user'
    },
    {
        _name: 'CSidebarNavItem',
        name: i18n.t('logout'),
        to: '/logout',
        icon: 'cil-power-standby'
    },
    {
        _name: 'CSidebarNavTitle',
    }
];

// Filter menu items based on user role
function getFilteredMenuItems() {
    try {
        const isAdmin = store.getters['users/isAdmin'];
        
        // Admin sees all items
        if (isAdmin) {
            return allMenuItems;
        }
        
        // User role (EcommerceManager) sees only allowed items
        if (store.getters['users/isUser']) {
            return allMenuItems.filter(item => {
                // Always show titles, profile and logout
                if (item._name === 'CSidebarNavTitle' || item.to === '/logout' || item.to === '/perfil') {
                    return true;
                }
                // Filter other items based on allowed pages
                return isPageAllowed(item.to);
            });
        }
    } catch (e) {
        // If store is not ready, return all items
        console.warn('Store not ready for menu filtering:', e);
    }
    
    // Default: show all (should not happen if user is logged in)
    return allMenuItems;
}

// Export function that returns filtered menu
export default function getNavMenu() {
    return [
        {
            _name: 'CSidebarNav',
            _children: getFilteredMenuItems()
        }
    ];
}